module.exports = __webpack_public_path__ + "static/img/bg-en.6dec75f8.webp";